import type { BasicFetch } from '../types/basicFetch';
import { concatByteArrays } from '../util/byteArray';

export async function fetchByteRange(
  fetch: BasicFetch,
  url: string,
  inclusiveStart: number,
  exclusiveEnd: number,
): Promise<Uint8Array> {
  const response = await fetch(url, {
    headers: [
      ['Range', `bytes=${inclusiveStart}-${exclusiveEnd - 1}`],
    ],
  });

  if (response.status !== 200 && response.status !== 206) {
    throw new Error(`Could not fetch ${url} (${response.status} ${response.statusText})`);
  }

  if (!response.body) {
    throw new Error(`Could not get body from ${url}`);
  }

  const buffers: Uint8Array[] = [];
  const reader = response.body.getReader();
  while (true) {
    const res = await reader.read();
    if (res.value) {
      buffers.push(res.value);
    }
    if (res.done) {
      break;
    }
  }

  return concatByteArrays(buffers);
}
